import React, { useMemo } from 'react';
import { map, times } from 'lodash';
import { Card, Container } from 'react-bootstrap';
import OwlCarousel from 'react-owl-carousel';
import { useTranslation } from 'react-i18next';
import { renderToString } from 'react-dom/server';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import '@components/Base/CustomOwlCarousel/style.scss';

import { Title } from '../title';

const options = {
  loop: true,
  center: false,
  items: 3,
  margin: 0,
  autoplay: false,
  dots: false,
  autoplayTimeout: 8500,
  smartSpeed: 450,
  nav: true,
  navText: [
    renderToString(<FontAwesomeIcon icon={faChevronLeft} size="2x" />),
    renderToString(<FontAwesomeIcon icon={faChevronRight} size="2x" />),
  ],
  responsive: {
    0: {
      items: 1,
    },
    720: {
      items: 2,
    },
    992: {
      items: 3,
    },
  },
};

const KeyFeatureSection = () => {
  const { t } = useTranslation();
  const items = useMemo(() => {
    return times(9, (n) => ({
      label: t(`carInsurancePage.keyFeatureSection.item${n + 1}.label`),
      desc: t(`carInsurancePage.keyFeatureSection.item${n + 1}.desc`),
    }));
  }, []);

  return (
    <section className="py-5 bg-light">
      <Title title={t('carInsurancePage.keyFeatureSection.title')}></Title>
      <Container>
        <OwlCarousel {...options} className="custom-owl-carousel custom-owl-carousel-nodots">
          {map(items, ({ label, desc }) => (
            <Card key={label} className="p-4 m-4 shadow-sm text-center" style={{ height: '200px' }}>
              <Card.Title>{label}</Card.Title>
              <Card.Text>{desc}</Card.Text>
            </Card>
          ))}
        </OwlCarousel>
      </Container>
    </section>
  );
};

export { KeyFeatureSection };
